import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { AdminViewAllOrders } from "../utils/Api/ApiCalls";
import { Link } from "react-router-dom";
import { useRecoilState } from "recoil";
import { OrderDetailState } from "../Services/RecoilAtoms";

const MonthYearFilter = ({ onMonthChange, onYearChange }) => {
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  // Generate last 10 years dynamically
  const years = Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i);

  const handleMonthChange = (event) => {
    const newMonth = parseInt(event.target.value);
    setSelectedMonth(newMonth);
    onMonthChange(newMonth);
  };

  const handleYearChange = (event) => {
    const newYear = parseInt(event.target.value);
    setSelectedYear(newYear);
    onYearChange(newYear);
  };

  return (
    <div className="d-flex gap-3 col-lg-2 col-6 col-md-3">
      {/* Month Dropdown */}
      <select className="form-select" value={selectedMonth} onChange={handleMonthChange}>
        {months.map((month, index) => (
          <option key={index} value={index}>{month}</option>
        ))}
      </select>

      {/* Year Dropdown */}
      <select className="form-select" value={selectedYear} onChange={handleYearChange}>
        {years.map((year) => (
          <option key={year} value={year}>{year}</option>
        ))}
      </select>
    </div>
  );
};


const MonthlyEarnings = () => {
  const [date, setDate] = useState(new Date());
  const [orderData, setOrderData] = useState();
  const [order, setOrder] = useRecoilState(OrderDetailState);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchValue, setSearchValue] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  // const [selectedYear, setSelectedYear] = useState()
  // Get the current month and year
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
  const [monthTotal, setMonthTotal] = useState(0);
  const [allData, setAllData] = useState([]);
  
  const itemsPerPage = 5;

  const [searchTerm, setSearchTerm] = useState("");
  const [temp, setTemp] = useState([]);

  const calculateTotalByMonth = (orders) => {
    const totalAmount = orders
      ?.filter(order => order.status === "success") // Filter only successful orders
      ?.reduce((sum, order) => sum + order.amount, 0); // Sum their amounts
    return totalAmount;
  };
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  // Simulate fetching items from another resources.
  // (This could be items from props; or items loaded in a local state
  // from an API endpoint with useEffect and useState)
  const endOffset = itemOffset + itemsPerPage;
  let currentItems = orderData?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(orderData?.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % orderData.length;
    setItemOffset(newOffset);
  };

  const fetchingOrders = async () => {
    try {
      const response = await AdminViewAllOrders();

      const filteredOrders = response?.data?.filter((order) => {
        const orderDate = new Date(order.createdDate);
        return (
          orderDate.getMonth() === currentMonth &&
          orderDate.getFullYear() === currentYear
        );
      });

     setAllData(response?.data)
      setOrderData(filteredOrders);
      setMonthTotal(calculateTotalByMonth(filteredOrders));
    } catch (err) {
      console.error(err);
    }
  };

  const filterByMonth = () => {
    const filteredOrders = allData?.filter((order) => {
      const orderDate = new Date(order.createdDate);
      return (
        orderDate.getMonth() === selectedMonth &&
        orderDate.getFullYear() === selectedYear
      );
    });
    
    setOrderData(filteredOrders);
    setMonthTotal(calculateTotalByMonth(filteredOrders));
  };

  useEffect(() => {
    fetchingOrders();
  }, []);

  const handleMonthChange = (newMonth) => {
    setSelectedMonth(newMonth);
  };

  const handleYearChange = (newYear) => {
    setSelectedYear(newYear);
  };

  useEffect(() => {
    filterByMonth();
  }, [selectedMonth, selectedYear]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const onSearch = () => {
    let data = temp.filter(
      (item, i) =>
        item["product_data"].productTitle.includes(searchTerm) ||
        item["product_data"].category.includes(searchTerm)
    );

    setOrderData(data);
  };

  return (
    <>
      <section class="content-main">
        <div class="content-header">
          <div>
            <h2 class="content-title card-title">
              Monthly Earnings - ₦ {monthTotal?.toLocaleString()}
            </h2>
            {/* <p>Orders from {currentMonth}.</p> */}
          </div>
          <div>
            {/* <input
              type="text"
              placeholder="Search order ID"
              class="form-control bg-white"
            /> */}
          </div>
          <div>
            <Link to="/orders" class="btn btn-primary">
              <i class="text-muted material-icons md-post_add"></i>All orders
            </Link>
          </div>
        </div>
        <div class="card mb-4">
          <header class="card-header">
            <div class="row gx-3">
              <div class="col-lg-4 col-md-6 me-auto">
                <input
                  type="text"
                  placeholder="Search by product title, category."
                  class="form-control"
                  value={searchTerm}
                  onChange={handleSearchChange}
                  onKeyUp={onSearch}
                />
              </div>
              <MonthYearFilter onMonthChange={handleMonthChange} onYearChange={handleYearChange}/>
              <div class="col-lg-2 col-6 col-md-3">
               
              </div>
            </div>
          </header>

          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Order ID</th>
                    <th scope="col">Customer Name</th>
                    <th scope="col">Customer Email</th>
                    {/* <th scope="col">Image</th> */}
                    <th scope="col">Total</th>
                    <th scope="col">Date</th>
                    <th scope="col">Shipping Type</th>
                    <th scope="col">Status</th>
                    <th scope="col" class="text-end">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems?.length > 0 ? (
                    <>
                      {currentItems &&
                        currentItems.map((props, i) => (
                          <tr key={props.id}>
                            <td>{props.orderId}</td>
                            <td>{props.customerName}</td>
                            <td>{props.customerEmail}</td>
                            {/* <td>
                            {/* <b>Marvin McKinney</b>
                            <b>{props["product_data"]?.productTitle}</b>
                            {/* <b>{props["user"]?.email}</b> 
                          </td> */}
                            {/* <td>
                            {" "}
                            <img
                              style={{ width: "40px", height: "30px" }}
                              // src={`http://localhost:7045/uploads/${props["product_data"]?.productImages[0].img}`}
                              src={`https://backend.argone.ng/uploads/${props["product_data"]?.productImages[0].img}`}
                              alt="#"
                            />
                          </td> */}
                            <td>₦{props?.amount?.toLocaleString()}</td>
                            {/* <td>
                            <span class="badge rounded-pill alert-success">
                              Completed
                            </span>
                          </td> */}
                            <td>
                              {new Date(props?.createdDate).toDateString()}
                            </td>
                            <td>
                              {props?.shippingType === 0
                                ? "Pick up"
                                : "Delivery"}
                            </td>
                            <td>{props?.status}</td>
                            <td class="text-end">
                              {/* <a href="#" class="btn btn-md rounded font-sm">
                                    Detail
                                  </a> */}
                              {/* <div class="dropdown">
                                <a
                                  href="#"
                                  data-bs-toggle="dropdown"
                                  class="btn btn-light rounded btn-sm font-sm"
                                >
                                  <i class="material-icons md-more_horiz"></i>
                                </a>
                                <div class="dropdown-menu">
                                  <a class="dropdown-item">
                                    <Link
                                      to={`/order/details/${props.orderId}`}
                                    >
                                      View details
                                    </Link>
                                  </a>

                                  
                                  <a class="dropdown-item text-danger" href="#">
                                    Delete
                                  </a>
                                </div>
                              </div> */}
                              <Link
                                // onClick={() => {
                                //   setOrder(props);
                                // }}
                                to={`/order/details/${props.orderId}`}
                              >
                                View details
                              </Link>
                            </td>
                          </tr>
                        ))}
                    </>
                  ) : (
                    <div>No order Found</div>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="pagination-area mt-30 mb-50">
          <nav aria-label="Page navigation example">
            <ReactPaginate
              nextLabel="Next"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              previousLabel="Previous"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link w-auto"
              nextClassName="page-item"
              nextLinkClassName="page-link w-auto"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination justify-content-start"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
          </nav>
        </div>
      </section>
    </>
  );
};

export default MonthlyEarnings;
